import React from 'react';

import { EditorsTable } from '../components/EditorsTable/EditorsTable';
import { useEditors } from '../hooks/useEditors';

import type { FC } from 'react';

export const Editors: FC = () => {
  const { data: editors = [], isLoading } = useEditors();

  return <EditorsTable editors={editors} loading={isLoading} />;
};
